import { IHallBooking } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	startDate?: number
	endDate?: number
	locationId?: string
	contactId?: string
	fetch?: {
		contact?: boolean
		location?: boolean
		hallBookingBill?: boolean
	}
	pagination?: {
		page: number
		limit: number
	}
}

export async function hallBookingListApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/list/v1"
	const requester = new ApiRequester<RequestDataShape, IHallBooking[]>(endpoint)
	return await requester.sendRequest(payload, token)
}
